/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type DeleteAttendanceRecordResponse = {
  success: boolean;
  message?: string;
  data?: {
    deletedRecordId: string;
    employeeId: string;
    day: string;
    deletedActivitiesCount: number;
    deletedApprovalsCount: number;
    deletedBy: {
      userId: string;
      name: string;
      role: string;
    };
  };
};

export const deleteAttendanceRecordRequest = async (
  recordId: string
): Promise<DeleteAttendanceRecordResponse> =>
  (
    await customAxios.delete<DeleteAttendanceRecordResponse>(
      `/attendance/delete-record/${recordId}`
    )
  ).data;

export const useDeleteAttendanceRecord = () => {
  const queryClient = useQueryClient();

  return useMutation<DeleteAttendanceRecordResponse, AxiosError, string>(
    deleteAttendanceRecordRequest,
    {
      onSuccess: (res) => {
        showNotification({
          title: "Attendance Deleted",
          message:
            res.message ?? "Attendance record deleted successfully.",
          color: "green",
        });

        // Invalidate all attendance-related queries
        queryClient.invalidateQueries(["admin-attendance-list"]);
        queryClient.invalidateQueries(["attendanceAdminList"]);
        queryClient.invalidateQueries(["attendance"]);
      },
      onError: (error) => {
        showNotification({
          title: "Error Deleting Attendance",
          message:
            (error.response?.data as { message?: string })?.message ??
            error.message ??
            "Failed to delete attendance record.",
          color: "red",
        });
      },
      retry: 1,
    }
  );
};
